module.exports = __webpack_public_path__ + "static/img/default.eebdb3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default.png
// module id = Lg5A
// module chunks = 0